export enum SwipeAction {
  Left,
  Right,
}
